// @core/api/endpoints/payment/list_payment_policies.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPaymentPoliciesResponse,
} from '../../../types/payment';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/payment';

/**
 * List payment policies
 * Returns a paginated list of payment policies. Supports filtering and sorting.
 */
export async function ListPaymentPolicies(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListPaymentPoliciesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/payment-policies`;
  const requestOptions = options;
  return client.get<ListPaymentPoliciesResponse>(requestPath, { ...requestOptions, params });
}
